import React, { FC, HTMLAttributes } from 'react';
import { cn } from '../../helpers';
import styles from './messagebubble.module.scss';

interface MessageBubbleProps extends HTMLAttributes<HTMLElement> {
    /**
     * Determine if the text should be truncated
     */
    truncate?: boolean;
}

/**
 * MessageBubble use as a content element
 * @param param0
 * @returns
 */
export const MessageBubble: FC<MessageBubbleProps> = ({ children, className, truncate, ...props }) => {
    const classes = cn(styles.messageBubble, className, {
        [className]: className,
        [styles.solid]: true,
        'text-truncate': truncate,
    });
    return (
        <p className={classes} {...props}>
            {children}
        </p>
    );
};
